var map = {
	"./IMG_20210620_125712_676.jpg": 42,
	"./IMG_20210704_151011_491.jpg": 43,
	"./frames-1.jpg": 44,
	"./frames-10.jpg": 45,
	"./frames-11.jpg": 46,
	"./frames-12.jpg": 47,
	"./frames-13.jpg": 48,
	"./frames-14.jpg": 49,
	"./frames-15.jpg": 50,
	"./frames-16.jpg": 51,
	"./frames-17.jpg": 52,
	"./frames-18.jpg": 53,
	"./frames-19.jpg": 54,
	"./frames-2.jpg": 55,
	"./frames-20.jpg": 56,
	"./frames-21.jpg": 57,
	"./frames-22.jpg": 58,
	"./frames-23.jpg": 59,
	"./frames-24.jpg": 60,
	"./frames-25.jpg": 61,
	"./frames-26.jpg": 62,
	"./frames-27.jpg": 63,
	"./frames-3.jpg": 64,
	"./frames-4.jpg": 65,
	"./frames-5.jpg": 66,
	"./frames-6.jpg": 67,
	"./frames-7.jpg": 68,
	"./frames-8.jpg": 69,
	"./frames-9.jpg": 70
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41;